import React, { useState } from 'react';
import cloneDeep from 'lodash.clonedeep';
import { Box } from '@mui/material';
import { TextTitle } from '../../../components/Text';
import Selector from '../../../components/Selectors/Selector';
import {
  flexGap2,
} from '../../../constants/lkCadastr/cadastrStorage';
import {
  MonitoringReport,
  MassWasteReport,
  EntitiesAcceptedReport,
  EntitiesTypeActivityReport,
  OrganizationsOverdueReport,
  AnalysisWasteReport,
  ConsolidatedReport,
} from './components';

import { reportOptions } from './constants';

const initialForm = {
  kind: reportOptions[0],
};

export default function DocsContent() {
  const [form, setForm] = useState({ ...initialForm });

  const {
    kind,
  } = form;

  const isMonitoringKind = kind.value === 'monitoring_status_reports';
  const isEntitiesAcceptedKind = kind.value === 'list_entities_accepted_reporting';
  const isEntitiesTypeActivityKind = kind.value === 'entities_type_activity';
  const isMassWasteKind = kind.value === 'mass_waste_transferred_tko';
  const isOrganizationsOverdueKind = kind.value === 'list_organizations_overdue_reporting';
  const isAnalysisWasteKind = kind.value === 'analysis_waste_fkko_codes';
  const isConsolidatedReportKind = kind.value === 'consolidated_report_legal_entities';


  const onChange = ({ target: { name } }, value) => {
    setForm({
      ...cloneDeep(initialForm),
      [name]: value,
    });
  };

  return (
    <Box>
      <TextTitle h2 sx={{ mb: '10px' }}>Создание отчета</TextTitle>
      <Box display="flex" gap={2} mb={2}>
        <Box sx={flexGap2}>
          <TextTitle sx={{ fontWeight: 'bold' }}>Название отчета</TextTitle>
          <Selector
            sx={{ width: '320px' }}
            label="Выберите название отчета"
            name="kind"
            value={kind}
            onChange={onChange}
            options={reportOptions}
          />
        </Box>
        {isMonitoringKind ? <MonitoringReport /> : isMassWasteKind
          ? <MassWasteReport /> : isEntitiesAcceptedKind
            ? <EntitiesAcceptedReport /> : isEntitiesTypeActivityKind
              ? <EntitiesTypeActivityReport /> : isOrganizationsOverdueKind
                ? <OrganizationsOverdueReport /> : isConsolidatedReportKind ? <ConsolidatedReport />
                  : isAnalysisWasteKind?<AnalysisWasteReport /> :<></>}
      </Box>
    </Box>
  );
}
